import { Select, SelectProps } from 'antd'
import { useState } from 'react'

import countries from 'constants/country'

const { Option } = Select

const SelectCountry = ({ value, disabled, onChange }: SelectProps) => {
  const [options, setOptions] = useState(countries)

  const handleChange = (value: string) => {
    onChange?.(value, {})
  }

  const handleSearch = (input: string) => {
    const filtered = countries.filter((c) => c.name.toLowerCase().includes(input.toLowerCase()))
    setOptions(filtered)
  }

  return (
    <Select
      showSearch
      //optionFilterProp='children'
      placeholder="Select a country"
      disabled={disabled}
      style={{ color: 'rgba(0, 0, 0, 0.85) !important' }}
      filterOption={false}
      onChange={handleChange}
      onSearch={handleSearch}
      value={value}
    >
      {options.map((country) => (
        <Option key={country?.code} value={country?.code}>
          <span style={{ color: 'rgba(0, 0, 0, 0.85)' }}>{country?.name}</span>
        </Option>
      ))}
    </Select>
  )
}

export default SelectCountry
